import { reactive } from 'vue';

const loading = reactive({
  setting: {
    isShow: false,
    content: '',
  },
  show,
  close,
});

function show(content) {
  loading.setting = {
    isShow: true,
    content,
  };
}

function close() {
  loading.setting = {
    isShow: false,
    content: '',
  };
}

export default loading;
